import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  permitApplicationId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useKeepPermitAsIs = ({
  permitApplicationId,
  onError,
  onSuccess,
}: Props) => {
  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      PermitApplicationClient.keepPermitAsIs({
        permitApplicationId,
      }),
    onSuccess,
    onError,
  });

  return {
    keepPermitAsIs: mutate,
    isPending,
  };
};
